import { useCallback, useState } from 'react';

import FormDialog from '@sayyesschool/frontend/components/form-dialog';
import PageSection from '@sayyesschool/frontend/components/page-section';
import { useManagers } from '@sayyesschool/frontend/features/managers';
import { useRequestActions } from '@sayyesschool/frontend/features/requests';
import { useUser } from '@sayyesschool/frontend/features/user';
import { useBoolean } from '@sayyesschool/frontend/hooks/state';

import RequestForm from '@/components/requests/request-form';
import RequestsList from '@/components/requests/requests-list';

export default function LearnerRequests({ learner }) {
    const [user] = useUser();
    const [managers] = useManagers();
    const actions = useRequestActions();

    const [requests, setRequests] = useState(learner?.requests || []);
    const [request, setRequest] = useState();
    const [isRequestFormOpen, toggleRequestFormOpen] = useBoolean(false);

    const handleCreateRequestRequest = useCallback(() => {
        setRequest({
            learner,
            learnerId: learner.id,
            managerId: user.id
        });
        toggleRequestFormOpen(true);
    }, [user, learner, toggleRequestFormOpen]);

    const handleCreateRequest = useCallback(data => {
        return actions.createRequest(data)
            .then(({ data: request }) => {
                setRequests(prevRequests => [...prevRequests, request]);
                toggleRequestFormOpen(false);
            });
    }, [actions, toggleRequestFormOpen]);

    const handleUpdateRequest = useCallback(data => {
        return actions.updateRequest(data.id, data)
            .then(() => toggleRequestFormOpen(false));
    }, [actions, toggleRequestFormOpen]);

    const handleDeleteRequest = useCallback(request => {
        return actions.deleteRequest(request.id)
            .then(() => actions.unsetRequest());
    }, [actions]);

    return (
        <PageSection
            className="LearnerRequests"
            title="Заявки"
            actions={[
                {
                    key: 'new',
                    icon: 'add',
                    title: 'Создать заявку',
                    onClick: handleCreateRequestRequest
                }
            ]}
            compact
        >
            {requests?.length > 0 &&
                <RequestsList requests={requests} />
            }

            <FormDialog
                title={request?.id ? 'Редактирование заявки' : 'Создание заявки'}
                open={isRequestFormOpen}
                submitButtonText={request ? 'Сохранить' : 'Создать'}
                onClose={toggleRequestFormOpen}
            >
                <RequestForm
                    id="request-form"
                    request={request}
                    managers={managers}
                    onSubmit={request?.id ? handleUpdateRequest : handleCreateRequest}
                />
            </FormDialog>
        </PageSection>
    );
}